import { useMemo } from 'react';
import { useGetUserPreferences } from '~/api/auth';
import { buildBuyListMatchInput } from './buyListFilters';
import { useMyBuyListSavedViews } from './useMyBuyListSavedViews';

export function useMyBuyListFilters() {
  const { isLoading } = useGetUserPreferences();
  const views = useMyBuyListSavedViews();
  const match = useMemo(() => buildBuyListMatchInput(views.rows), [views.rows]);

  return {
    isLoading: isLoading || (views.isLoadingViews && !views.isViewsError),
    views,
    rows: views.rows,
    match,
  };
}
